import {Modal, ModalBody, ModalFooter, ModalOverlay, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'
import {useTranslation} from '@/translations/i18n'
import {StyledModalHeader} from './style'
import {Button} from '@/components/ui/button/Button'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {MedicalReportValidationSchema} from '../../formSchemas'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {Text} from '@/components/ui/text/Text'

export const MedicalReportConfirmationModal = ({
    onClose,
    onConfirm,
    isLoading,
    patientFullName
}: {
    onClose: () => void
    onConfirm: () => void
    isLoading: boolean
    patientFullName: string
}) => {
    const {t} = useTranslation()
    const form = useFormContext<MedicalReportValidationSchema>()
    const status = useWatch({control: form.control, name: 'status'})
    const reportType = useWatch({control: form.control, name: 'reportType'})

    return (
        <>
            <ModalOverlay
                onClick={event => {
                    event.stopPropagation()
                    onClose()
                }}
            />
            <Modal width="400px" onClick={event => event.stopPropagation()}>
                <StyledModalHeader>
                    <ModalTitle>{t('commons:add_report')}</ModalTitle>
                    <Flexbox direction="column" gap={1}>
                        <Text size="textMd">{reportType.name}</Text>
                        <Text size="textSm" palette="neutral" shade="500">
                            {t('medical_records:for_patient_name', {patientFullName})}
                        </Text>
                    </Flexbox>
                </StyledModalHeader>
                <ModalBody>
                    <Controller
                        control={form.control}
                        name="status"
                        render={({field}) => (
                            <FormFieldBox fitContent isSelected={field.value == 'signed'}>
                                <Checkbox
                                    id="sign-check"
                                    checked={field.value == 'signed'}
                                    label={t('commons:operators_signature')}
                                    onChange={() =>
                                        status == 'draft' ? field.onChange('signed') : field.onChange('draft')
                                    }
                                />
                            </FormFieldBox>
                        )}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={onClose}>
                        {t('commons:cancel')}
                    </Button>
                    <Button disabled={status != 'signed' || isLoading} variant="primaryNeutral" onClick={onConfirm}>
                        {isLoading && <Spinner />}
                        {t('commons:confirm')}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
